import frMessages from "../locales/fr_FR.json";
import { LangConfig } from "../model";

export const FrLang: LangConfig = {
  messages: {
    ...frMessages,
  },
  locale: "fr-FR",
};
